/**
 * KEEP IN SYNC with functions/src/utils/lockedDataAdapter.ts
 *
 * Single place that derives the payout amount ("Att utbetala") from
 * snapshot totals, with fallback for snapshots created before
 * schemaVersion 2 (which lack amountToPay) and for stale-client
 * PDF payloads.
 *
 * Sync note: the functions copy inlines the rounding formula (no shared
 * package); behavior must stay identical to roundMoney.
 */
import { roundMoney } from '@/lib/money'

export interface PayoutTotalsLike {
  amountToPay?: number
  finalNetPayout?: number
  finalNetSalary: number
  cashReceived?: number
}

export function getAmountToPay(totals: PayoutTotalsLike): number {
  if (totals.amountToPay !== undefined) {
    return totals.amountToPay
  }
  const fallback = (totals.finalNetPayout ?? totals.finalNetSalary) - (totals.cashReceived ?? 0)
  // Same rounding policy as the engine, so legacy snapshots resolve
  // to exactly the value the engine would produce
  return roundMoney(fallback)
}
